module.exports = __webpack_public_path__ + "img/horizontal_6_3_pp3_8004.34b25dc8.png";